export const blockIconsActivitiesSportsBaseballNew = (
	<span className='material-symbols-outlined'>sports_baseball</span>
);
